// Simple user store without external dependencies
let currentUser: {
  id: string;
  email?: string | null;
  name?: string | null;
  passkey?: {
    credentialId: string;
    publicKeyX: string;
    publicKeyY: string;
    address?: string;
  };
  walletAddress?: string | null;
} | null = null;

// Stable function references
const setUser = (user: any) => {
  currentUser = user;
};

const logout = () => {
  currentUser = null;
};

const canAccessFeature = (_feature: string) => true;

export const useUserStore = () => ({
  user: currentUser,
  isAuthenticated: !!currentUser,
  walletAddress: currentUser?.passkey?.address || currentUser?.walletAddress || null,
  hasKyc: false,
  setUser,
  logout,
  canAccessFeature,
});
